import { Apollo } from 'apollo-angular';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { SEND_RESET_EMAIL, RESET_PASSWORD } from './forgot-password.gql';
import { forgotPassword, forgotPasswordVariables } from './types/forgotPassword';
import { resetPassword, resetPasswordVariables } from './types/resetPassword';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  forgotPasswordForm: UntypedFormGroup;
  requestEmailForm: UntypedFormGroup;
  hasToken: boolean;
  queryParams: Observable<{}>;
  sub: Subscription;
  forgotBtnloading: boolean = false;

  constructor(
    fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private apollo: Apollo,
    private toastr: ToastrService
  ) {
    this.forgotPasswordForm = fb.group({
      email: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, Validators.required),
      confirmPassword: new UntypedFormControl(null, Validators.required),
      token: new UntypedFormControl(null),
    });

    this.requestEmailForm = fb.group({
      email: new UntypedFormControl(null, Validators.required)
    });
  }

  ngOnInit(): void {
    this.queryParams = this.route.queryParamMap;
    this.sub = this.queryParams.subscribe(response => {
      if (response['params']['email'] && response['params']['token']) {
        this.hasToken = true;
        this.forgotPasswordForm.patchValue({
          email: response['params']['email'],
          token: response['params']['token']
        });
      } else {
        this.hasToken = false;
      }
    });
  }

  onResetEmailSubmit() {
    this.apollo
    .query<forgotPassword, forgotPasswordVariables>({
      query: SEND_RESET_EMAIL,
      variables: this.requestEmailForm.value,
    })
    .subscribe(
      ({ data }) => {
        if (data.forgotPassword.success) {
          this.toastr.success('Email sent!', null, {
            timeOut: 3000,
          });
        } else {
          this.toastr.error(data.forgotPassword.message, null, {
            timeOut: 5000,
          });
        }
      },
      error => {
        this.toastr.error(error.message, null, {
          timeOut: 5000,
        });
      }
    );
  }

  onChangePasswordSubmit() {
    this.forgotBtnloading = true;
    this.apollo
    .mutate<resetPassword, resetPasswordVariables>({
      mutation: RESET_PASSWORD,
      variables: this.forgotPasswordForm.value
    })
    .subscribe(
      ({ data }) => {
        if (data.resetPassword.success) {
          this.forgotBtnloading = false;
          this.toastr.success('Password changed sucessfuly!', null, {
            timeOut: 3000,
          });
          this.router.navigate(['./../login'], { relativeTo: this.route });
        } else {
          this.toastr.error(data.resetPassword.message, null, {
            timeOut: 5000,
          });
        }
      },
      error => {
        this.forgotBtnloading = false;
        this.toastr.error(error.message, null, {
          timeOut: 5000,
        });
      }
    );
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
